import { LEAVE_SCHOOL } from './api'
import { METHOD, request } from '@/utils/request'
import download from './downloadFile'

/**
 * 查询毕业离校学生
 * @param {*} params 
 * @returns 
 */
export function findAll(params) {
    return request(LEAVE_SCHOOL + '/graduationStudentItem/getAllGraduationStudentItems', METHOD.GET, params)
}

/**
 * 批量发送学生的事项消息
 * @param {*} data 
 * @returns 
 */
export function sendMsg(data) {
    return request(LEAVE_SCHOOL + '/sendMsg/sendMsg', METHOD.POST, data)
}

/**
 * 批量通过学生事项
 * @param {*} data 
 * @returns 
 */
export function passStudentItem(data) {
    return request(LEAVE_SCHOOL + '/graduationStudentItem/passStudentItem', METHOD.POST, data)
}

/**
 * 暂缓办理学生事项
 * @param {*} data 
 * @returns 
 */
 export function stopStudentItem(data) {
    return request(LEAVE_SCHOOL + '/graduationStudentItem/stopStudentItem', METHOD.POST, data)
}

/**
 * 批量撤回学生事项
 * @param {*} data 
 * @returns 
 */
export function recallStudentItem(params) {
    return request(LEAVE_SCHOOL + '/graduationStudentItem/recallStudentItem', METHOD.POST, null, {params})
}

/**
 * 返回事项id, 部门，事项，状态
 * @returns 
 */
export function listStudentItemStatus(params) {
    return request(LEAVE_SCHOOL + '/graduationStudentItem/getStudentOrganizationItemList', METHOD.GET, params)
}

/**
 * 下载离校事项导入模板（
 */
export function downloadStudentLeavingExcel(params) {
    // window.location.href = API + '/templeteConfig/downloadStudentLeavingExcel'
    // download(API + '/templeteConfig/downloadStudentLeavingExcel', null, '离校管理导入模板.xlsx')
    download(LEAVE_SCHOOL + '/graduationStudentItem/downStudentTemplete', params, '离校管理导入模板.xlsx')
}

/**
 * 导入离校事项
 * @param {*} data 
 * @returns 
 */
export function uploadStudentLeavingExcel(params) {
    return request(LEAVE_SCHOOL + '/graduationStudentItem/importStudentItems', METHOD.POST, null, {params})
}

/**
 * 根据用户查询字段
 * @returns 
 */
export function getColumns(){
    return request(LEAVE_SCHOOL + '/graduationStudent/getColumns', METHOD.GET)
}


export function downloadStudentItemExcel(params){
    // window.location.href = LEAVE_SCHOOL + '/graduationStudentItem/downStudentItem?' + params2link(params)
    download(LEAVE_SCHOOL + '/graduationStudentItem/downStudentItem', params, '离校管理.xlsx')
}

/**
 * 修改状态
 * @param {x} data 
 * @returns 
 */
export function editStudentItemStatus(data){
    return request(LEAVE_SCHOOL + '/graduationStudentItem/editStudentItemStatus', METHOD.POST, data)
}